import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const user = JSON.parse(localStorage.getItem('user'));

const createFinancier = async (data) => {
  const response = await axios.post(API_URL + "api/financier", { ...data, "dealer_id": user.dealer_id }, { headers: authHeader() });
  return response.data;
};

const getFinancier = async () => {
  const response = await axios.get(API_URL + `api/financier/dealer/${user.dealer_id}`, { headers: authHeader() });
  return response.data;
};

const updateFinancier = async (c_id, formData) => {
  const response = await axios.put(API_URL + `api/financier/id/${c_id}`, {...formData}, { headers: authHeader() });
  return response.data;
};

const deleteFinancier = async (c_id) => {
  const response = await axios.delete(API_URL + `api/financier/id/${c_id}`, { headers: authHeader() });
  return response.data;
};


const financeService = {
  createFinancier,
  updateFinancier,
  deleteFinancier,
  getFinancier
};

export default financeService